import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Do I need expensive equipment?',
    a: 'No. Everything you need (cold water, a place to elevate your legs, and real food) is already in your home.'
  }, {
    q: "Is this safe if I'm on HRT?",
    a: 'Yes, this is a natural lifestyle protocol, but we always recommend consulting your physician first.'
  }, {
    q: 'Do I have to quit coffee?',
    a: "No, we just show you how to time it strategically so it doesn't ruin your morning cortisol rhythm."
  }, {
    q: 'How do I receive the product?',
    a: 'You will receive an email with instant access to the PDF immediately after your secure purchase.'
  }];
  return <section className="bg-white pt-12 pb-10" data-id="element-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-35">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-2xl overflow-hidden bg-white" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" aria-expanded={openIndex === index} data-id="element-38">
                <span className="font-bold text-lg text-deep-teal" data-id="element-39">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>
              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}